import { useSkillsFrameworksOptions } from "PFCore/hooks/queries/skills_frameworks/use_skills_frameworks_options";
import { Id, SkillsFramework } from "PFCore/types";

export const useSelectedSkillsFrameworks = (skillsFrameworksIds: Id[] | null) => {
  const isSkillsFrameworkConnected = !!((skillsFrameworksIds || []).length > 0);

  const { data: skillsFrameworks, isLoading: isSkillsFrameworksLoading } = useSkillsFrameworksOptions(
    { ids: skillsFrameworksIds! },
    {
      enabled: isSkillsFrameworkConnected
    }
  );

  return {
    selectedSkillsFrameworks: (skillsFrameworks?.entries || []) as SkillsFramework[],
    isSkillsFrameworksLoading
  };
};
